import "core-js/modules/es.array.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.concat.js";
import React from 'react';
import { makeStyles, Typography, RED } from '@applyboard/ui-components';
import { check_mark, close } from "../../../../../../../../../assets/images/Results";
var useStyles = makeStyles({
  icon: {
    position: 'relative',
    paddingRight: '5px',
    paddingLeft: '14px',
    bottom: '2px'
  },
  close: {
    paddingLeft: '15px',
    paddingRight: '8px'
  },
  score: {
    textAlign: 'right',
    marginRight: function marginRight(props) {
      return props.pass === null || props.pass === undefined ? '35px' : null;
    }
  }
});
function getFlattenedContent(children, requiredScores) {
  return children.map(function (score, idx) {
    if (idx === 0 && Number(score) >= Number(requiredScores[0])) {
      return score;
    }
    var separator = idx === 0 ? ' ' : '; ';
    return /*#__PURE__*/React.createElement("span", {
      key: idx,
      style: {
        color: RED[9]
      }
    }, separator, score);
  });
}
var StudentScore = function StudentScore(_ref) {
  var pass = _ref.pass,
    children = _ref.children,
    _ref$requiredScores = _ref.requiredScores,
    requiredScores = _ref$requiredScores === void 0 ? null : _ref$requiredScores,
    _ref$gpa = _ref.gpa,
    gpa = _ref$gpa === void 0 ? false : _ref$gpa;
  var classes = useStyles({
    pass: pass
  });
  var imgSrc = pass ? check_mark : close;
  return /*#__PURE__*/React.createElement(Typography, {
    className: classes.score,
    variant: "paragraph"
  }, !gpa && Array.isArray(children) ? getFlattenedContent(children, requiredScores) : children, pass != null && /*#__PURE__*/React.createElement("img", {
    alt: "",
    src: imgSrc,
    className: "".concat(classes.icon, " ").concat(!pass ? classes.close : null)
  }));
};
export default StudentScore;